import { render, staticRenderFns } from "./ReviewDetail.vue?vue&type=template&id=31dd5209&scoped=true&"
import script from "./ReviewDetail.vue?vue&type=script&lang=js&"
export * from "./ReviewDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReviewDetail.vue?vue&type=style&index=0&id=31dd5209&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dd5209",
  null
  
)

export default component.exports